import { Core } from "@faire/design-tokens";
import type { IBrandViewV2Response } from "@faire/web-api/indigofair/data/IBrandViewV2Response";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";

import type { IReviewSummary } from "@faire/retailer/lib/buildReviewSummary";

import { Rating } from "./Rating";
import { StoryModalButton } from "./StoryModalButton";
import * as styles from "./styles.css";

export const StoryAndRatingsCard: React.FC<{
  brand: IBrandViewV2Response.ILeanBrand;
  brandAboutSubheader: string | null;
  reviewSummary: IReviewSummary | undefined;
}> = ({ brand, brandAboutSubheader, reviewSummary }) => {
  if (!brand.description) {
    return null;
  }
  return (
    <Column
      className={styles.storyTileWrapper}
      align="start"
      data-test-id="story-and-ratings-card"
    >
      {brand.name ? (
        <Typography
          as="h2"
          variant={{
            mobileAndAbove: "paragraphSansMedium",
            xxLargeDesktop: "subheadingSansMedium",
          }}
          color={Core.text.default}
        >
          <StrictLocalMsg
            defaultMessage="About {brandCompanyName}"
            description={{
              text: "About brand header",
            }}
            values={{ brandCompanyName: brand.name }}
          />
        </Typography>
      ) : null}

      {reviewSummary ? (
        <>
          <Spacer height={4} />
          <Rating reviewSummary={reviewSummary} size="small" />
        </>
      ) : null}

      <Spacer height="1x" />
      <Typography
        className={styles.truncatedStoryText}
        color={Core.text.default}
      >
        {brand.description}
        <span className={styles.overlayText}>
          <StoryModalButton
            brand={brand}
            brandAboutSubheader={brandAboutSubheader}
          />
        </span>
      </Typography>
    </Column>
  );
};
